<template>
  <div v-if="product">
    <portlet
            :actionsBlock="true"
            :icon="'fad fa-boxes'"
            :title="title"
    >
      <template slot="actionsBlock">
        <back-button :link="'products'"/>
      </template>
      <template slot="portletBody">
        <div class="row">
          <div class="form-group col">
            <label for="product-name">{{$t('products.name')}}</label>
            <input class="form-control"
                   id="product-name"
                   name="product-name"
                   type="text"
                   v-model="product.name"
                   v-validate="'required'">
          </div>
        </div>
      </template>
    </portlet>

    <div class="row">
      <div class="col product-properties">
        <portlet
                :icon="'fad fa-list'"
                :title="$t('products.properties.title')"
        >
          <template slot="portletBody">
            <product-properties
                    :product="product"
                    @addedRow="addedRow($event)"
            />
          </template>
        </portlet>
      </div>
    </div>
    <div class="row">
      <div class="col product-workflows">
        <portlet
                :icon="'fad fa-project-diagram'"
                :title="$t('products.workflows.title')"
        >
          <template slot="portletBody">
            <product-workflows
                    :product="product"
                    @addedRow="addedRow($event)"
            />
          </template>
        </portlet>
      </div>
    </div>

    <div class="col-12 text-right bg-white m-box-shadow pr-5 pl-5 pt-4 pb-4">
      <router-link :to="{name:'products'}" class="btn btn-cancel">
        {{$t('ui.cancel')}}
      </router-link>
      <button @click="saveProduct()" class="btn btn-primary ml-3" type="button">
        {{$t('ui.save')}}
      </button>
    </div>

  </div>
</template>

<script>
  import ProductProperties from './ProductProperties';
  import ProductWorkflows from './ProductWorkflows';

  //@vuese
  // @group Products
  export default {
    name: 'ProductGeneral',
    components: {
      ProductProperties,
      ProductWorkflows
    },
    provide() {
      return {
        $validator: this.$validator
      };
    },
    props: ['product', 'documentId'],
    data() {
      return {
        title: null,
        productCopy: null,
        rowAddedEvent: false,
        productBackup: null
      };
    },
    methods: {
      //@vueuse
      addedRow(event) {
        this.rowAddedEvent = event;
      },
      //@vueuse
      saveProduct() {
        this.$validator.validateAll().then((result) => {
          let validationArrayChild = this.$children.map(function (child) {
            return child.$validator.validateAll();
          });
          Promise.all(validationArrayChild).then((v) => {
            let validCheck = _.includes(v, false);
            if(result && !validCheck) {
              this.productData = Object.assign({}, this.product);
              this.productData.createdBy = this.$store.getters.getUserData;
              this.productData.properties = _.reject(this.productData.properties, ['name', null]);
              this.productData.workflows = _.compact(this.productData.workflows);
              this.productCopy = JSON.parse(JSON.stringify(this.product));

              this.$store.dispatch('products/set', this.productData).then(() => {

                this.$emit('unsavedChanges', false);
                this.productCopy = JSON.parse(JSON.stringify(this.product));
                this.swalToastSuccess(this.$t('products.updated'));
                this.$emit('productSaved', {saved: true, unsavedChanges: false});
                this.$emit('unsavedChanges', false);
              }).catch(() => {
                this.$toasted.global.failedRequest();
              });
            } else {
              this.$toasted.global.failedFormRequest();
            }
          });
        });
      }
    },
    watch: {
      //@vueuse
      rowAddedEvent: {
        handler(rowAdded) {
          if(rowAdded) {
            this.productCopy = JSON.parse(JSON.stringify(this.product));
          }
        }
      },
      //@vueuse
      product: {
        handler(productData) {
          delete productData.updated_at;
          delete productData.createdBy;
          delete this.productCopy.updated_at;
          delete this.productCopy.createdBy;
          this.$emit('unsavedChanges', JSON.stringify(productData) !== JSON.stringify(this.productCopy));
          this.$emit('resetValue', this.productBackup);
        },
        deep: true
      },
      //@vueuse
      'product.workflows': {
        handler() {
          this.productBackup = JSON.parse(JSON.stringify(this.product));
        }
      }
    },
    created() {
      this.title = this.product.name;
      let jsonParse = JSON.parse(JSON.stringify(this.product));
      this.productCopy = jsonParse;
      this.productBackup = jsonParse;
    }
  };
</script>